import React, { Component } from 'react';
import {connect} from 'react-redux';
import withRouter from 'react-router-dom/withRouter';
import CardHelper from '../../../../components/CardNew/helpers';
import { setMetricsEvent } from "../../../../actions/metrics";
import { CARRUSELESINICIO, MUNDIAL2022, URLVCARDEQUIPOS, URLEQUIPOS } from '../../../utls/constants';
import Utils from '../../../../utils/Utils';
import './_styles.scss';
import Asset from 'src/requests/apa/Asset';

class TeamsCard extends Component {
    constructor(props) {
      super(props);
      this.init(props);
      this.team = props.team;
      this.handleOnClick = this.handleOnClick.bind(this)
    }

    init(props) {
      this.focusHandler = props.focusHandler;
      this.data = props.data || {};
      this.data.api = props.api;
    }

    componentDidMount() {
      window.SpatialNavigation.makeFocusable();
    }

    componentDidUpdate() {
      window.SpatialNavigation.makeFocusable();
    }

    handleOnClick() {
      Utils.sendMetric(this.props, MUNDIAL2022,  `${this.props.team.name}`, CARRUSELESINICIO);
      const { history } = this.props;
      if(this.props.id <= 4) {
        history.push(`${URLVCARDEQUIPOS}${this.team.id}`);
      } else{
        history.push(URLEQUIPOS);
      }
    }

    render() {
      return (
        <a
          onClick={this.handleOnClick}    
          id={this.props.id} 
          href = "javascript:void(0)"
          className =  {`container-team focusable`}
          data-sn-up={this.props.focusUp}
          data-sn-left={this.props.focusLeft}
          data-sn-right={this.props.focusRight}
          onFocus={() => {CardHelper.focusHandler(this.focusHandler, this.data);}}
          >   
          <div className="team-image-container">
            {this.props.isFlag && <img className="team-image" src={this.team.logo ? this.team.logo : Asset.get("ribbon_team_placeholder_img", "")} alt={this.team.name}/> }
            {!this.props.isFlag && <span className='ver-todos'>VER TODOS</span> }
          </div>
          {this.props.isFlag && <div className="team-name">{this.team.name}</div>}
          {!this.props.isFlag && <div className='team-name team-name-hidden'>{'Ver Todos'}</div> }
        </a>
      );
    }
}


export default connect(null, {setMetricsEvent})(withRouter(TeamsCard));



// WEBPACK FOOTER //
// ./src/mundial/RibbonTypes/CardsTypesMundial/TeamsCard/index.jsx